  import styled from "styled-components";

  export const Container = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;

    @media (max-width: 768px) {
      display: flex;
      flex-direction: column;
      width: 100%;
      box-sizing: border-box;
      overflow: hidden;
  }
  `;
  export const LisaContainer = styled.div`
    display: flex;
    width: 100%;
    height: 100%;
    @media (max-width: 768px) {
      height: 100%;
      width: 100%;
    }

    video{
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      overflow: hidden;
    }


    .librasReplyButtonContainer {
      height: 5rem;
      width: 100%;
      padding: 5px;
      position: absolute;
      display: flex;
      justify-content: flex-end;
    }

          
      #lisaAvatar{
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        align-items: center;
    
        canvas{
        }
      }
    

    .webcam {
      height: auto;
      width: 20%;
      background: black;
      z-index: 10;
    }
  `;

